import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { t } from 'i18next';

//  components
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AppCodeArea } from 'components/ui';
import { Skeleton } from '@mui/material';

// types
import { IUserDiagnostic } from 'types/models/UserDiagnosticsModel';
import { UserDignosticsFilesTab } from './UserDignosticsFilesTab';
import { UserDignosticsDevopsIntegrationTab } from './UserDignosticsDevopsIntegrationTab';

interface IUserDiagnosticsMangeTabProps {
    isLoading: boolean;
    isCreatingTicket: boolean;
    isDownloadingUserDiagnosticsFile: boolean
    userDiagnostic: IUserDiagnostic | null
}

export const UserDiagnosticsMangeTab = observer(({ isLoading, isCreatingTicket, isDownloadingUserDiagnosticsFile, userDiagnostic }: IUserDiagnosticsMangeTabProps) => {
    const [activeTab, setActiveTab] = useState<string>('raw_data');

    const tabs: string[] =
        [
            'raw_data',
            'files',
            'devops_integration'
        ]

    const handleChangingTabs = (_event: React.SyntheticEvent, newValue: string) => {
        setActiveTab(newValue);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'raw_data':
                return <AppCodeArea title={t('UserDiagnostics.Column.RawInfo')} content={userDiagnostic?.rawInfoContext ?? '{}'} />
            case 'files':
                return <UserDignosticsFilesTab isDownloadingUserDiagnosticsFile={isDownloadingUserDiagnosticsFile} userDiagnostic={userDiagnostic} />
            case 'devops_integration':
                return <UserDignosticsDevopsIntegrationTab userDiagnostic={userDiagnostic} isHandlingTicket={isCreatingTicket} />
            default:
                return null;
        }
    };

    return (
        <>
            {isLoading ? (
                <div className='container'>
                    <Skeleton variant='rectangular' height={200} />
                </div>
            ) :
                (
                    <div className='container tabs'>
                        <>
                            <Tabs className='tabs__header' value={activeTab} onChange={handleChangingTabs} aria-label='support files'>
                                {tabs.map((tabType) => (
                                    <Tab
                                        label={t(`UserDiagnostics.Tab.${tabType}`).toString()}
                                        id={`${tabType}-tab`}
                                        aria-controls={`${tabType}-tabpanel`}
                                        value={tabType}
                                        key={tabType}
                                    />
                                ))}
                            </Tabs>

                            {tabs.map((tabType) => (
                                <div
                                    role='tabpanel'
                                    hidden={activeTab !== tabType}
                                    id={`${tabType}-tabpanel`}
                                    aria-labelledby={`${tabType}-tab`}
                                    key={tabType}
                                >
                                    {renderTabContent()}
                                </div>
                            ))}
                        </>
                    </div>
                )
            }
        </>
    );
})